import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SetupAdmin from './SetupAdmin';
import { useAuth } from '../../context/AuthContext';
import RegistrationNotes from './RegistrationNotes';
import './AdminDashboard.css';

const AdminDashboard: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser, isAdmin, adminLoading } = useAuth();
  const [showRegistrationNotes, setShowRegistrationNotes] = useState(false);

  if (adminLoading) {
    return (
      <div className="admin-dashboard">
        <h1>Loading...</h1>
      </div>
    );
  }

  if (!currentUser) {
    return (
      <div className="admin-dashboard">
        <h1>Please log in to access admin features</h1>
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div className="admin-dashboard admin-access-required">
        <h1>Admin Access Required</h1>
        <p>You need admin privileges to access this section.</p>
        <div className="setup-admin-container">
          <SetupAdmin />
        </div>
      </div>
    );
  }

  return (
    <div className="admin-dashboard">
      <h1>Admin Dashboard</h1>
      
      <div className="admin-cards">
        <div className="admin-card rainbow-red" onClick={() => navigate('/admin/campers')}>
          <h2>Camper Management</h2>
          <p>View and manage camper profiles, history, and registration data</p>
        </div>

        <div className="admin-card rainbow-orange" onClick={() => navigate('/admin/annual-settings')}>
          <h2>Annual Settings</h2>
          <p>Manage camp dates, registration fees, and accommodation rates for the year</p>
        </div>

        <div className="admin-card rainbow-yellow" onClick={() => navigate('/admin/inventory')}>
          <h2>Inventory Management</h2>
          <p>Manage cottages, apartments, dorms, and campsite inventory</p>
        </div>

        <div className="admin-card rainbow-green" onClick={() => navigate('/admin/assignments')}>
          <h2>Accommodation Assignment</h2>
          <p>Assign and manage accommodation bookings for registrants</p>
        </div>

        <div className="admin-card rainbow-blue" onClick={() => navigate('/admin/reports')}>
          <h2>Operational Reports</h2>
          <p>View registration reports, occupancy statistics, and financial summaries</p>
        </div>

        <div className="admin-card rainbow-purple" onClick={() => navigate('/admin/agm-report')}>
          <h2>AGM Report</h2>
          <p>Generate annual general meeting report with historical data and registrar narrative</p>
        </div>

        <div className="admin-card rainbow-red" onClick={() => navigate('/admin/users')}>
          <h2>Admin Users</h2>
          <p>Manage administrator access and permissions</p>
        </div>

        <div className="admin-card rainbow-orange" onClick={() => setShowRegistrationNotes(true)}>
          <h2>Registration Notes</h2>
          <p>View and manage registration-related notes and reminders</p>
        </div>

        <div className="admin-card rainbow-yellow" onClick={() => navigate('/admin/dev-tools')}>
          <h2>Development Tools</h2>
          <p>Access database management, testing utilities, and development settings</p>
        </div>
      </div>

      {/* Registration Notes Modal */}
      {showRegistrationNotes && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button
              className="close-button"
              onClick={() => setShowRegistrationNotes(false)}
            >
              ×
            </button>
            <RegistrationNotes />
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminDashboard; 